import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      camper, // via query
      session, // via query
      camperSession, // via query
      setCartDays // via redux actions
    } = props

    const handleChangeDays = e => {
      const days = e.target.value
      setCartDays({ camper, session, camperSession, days })
    }

    return <WrappedComponent onChangeDays={handleChangeDays} {...props} />
  }
}

export default withEventHandlers
